<template>

  <tr v-show="isShow" v-bind:class="bgNode"   >
    <td>
      <span v-bind:style="styleTree"
            class="indicador-nome tree-label fa"
            style="cursor: pointer">
        <i @click="toogleExpande()" class="fa pr-2" v-bind:class="iconLine"></i>
         <span class="node-name" @click="selectIndicador()">{{node.nome}}</span>
      </span>
    </td>
    <td>
      <div class="text-center">
        <i v-bind:class="icon_requisito(node.requisito_id)" class="fa"></i>
      </div>
    </td>

    <template v-for="competencia in node.competencias">
      <td class="cell-value">
        <div class="d-flex flex-column align-items-stretch" style="padding-right: .1em">

          <template v-if="competencia.apurado">
            <div class="meta-info p-1" style="word-wrap: normal">{{ format_value(competencia.meta)}}</div>
            <div class="p-1 clickable"
                 :class="style_bate_meta(competencia.bateu, competencia.realizado)"
                 @click="onHandleDatailNota(competencia)">
              {{ valor_realizado(competencia.realizado)}}
            </div>
          </template>
          <template v-else>
            <div class="meta-info p-1"><span>N/A</span></div>
            <div class="nao-apurado p-1 "><span>N/A</span></div>
          </template>
        </div>
      </td>
    </template>
  </tr>
</template>

<style src="@/assets/css/relatorio.css" scoped></style>

<script>
  import * as utils from '@/domain/utils'
  import * as _ from "lodash";
  import {mapActions, mapState} from "vuex"
  import collect from 'collect.js'
  import {MessageBox} from 'element-ui'
  import DatailMeta from '../Shared/DatailMeta'

  export default {
    props: ['node', 'nivel', 'parent_id', 'showGraph'],
    data() {
      return {}
    },
    computed: {
      ...mapState('Relatorio', ['indicadoresAbertos']),
      isShow() {
        return utils.is_parent(this.parent_id) || collect(this.indicadoresAbertos).contains(this.parent_id)
      },
      imOpen() {
        if (!utils.is_parent(this.parent_id)) {
          return false
        }
        const indicadores = collect(this.indicadoresAbertos)
        return indicadores.contains(this.node.id)
      },
      styleTree() {
        return {
          'margin-left': this.nivel === 1 ? '.2em' : (this.nivel * 1.5) + "em"
        }
      },
      iconLine() {
        if (_.isEmpty(this.node.childrens)) {
          return 'icon-arrow-right'
        }
        if (!_.isUndefined(this.parent_id)) {
          return 'fa-level-up fa-rotate-90'
        }
        return this.imOpen ? 'el-icon-minus' : 'el-icon-plus'
      },
      bgNode() {
        return _.isUndefined(this.parent_id) ? 'background-parent' : 'background-children';
      }
    },
    methods: {
      ...utils,
      ...mapActions('Relatorio', ['setIndicadoresAbertos', 'setIndicadorSelectedId']),
      toogleExpande() {
        this.setIndicadoresAbertos(this.node.id)
      },
      selectIndicador() {
        this.setIndicadorSelectedId(this.node.id)
        this.$emit("update:showGraph", true)
      },
      onHandleDatailNota(meta) {
        meta.indicador_nome = this.node.nome
        this.$emit('metaSelected', { meta})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Periodo/IndicadorLine.vue